import "./login.css";

export default function Login(props) {
  // console.log("login", props);

  return (
    <div className="loginPage">
      <h2>Please connect your wallet to Metamask <span>↗</span></h2>
    </div>
  );
}
